import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import type { Entity } from './entities';

/**
 * Fires when a button is clicked
 */
export interface ButtonClick {
  /**
   * text within the button in english
   */
  buttonName: string;
}

export const buttonClick = (data: ButtonClick, context?: Entity[]) =>
  trackSelfDescribingEvent({
    event: { schema: 'iglu:com.starsgroup/button_click/jsonschema/1-0-0', data },
    context
  });
